import { render, staticRenderFns } from "./education-video-player.vue?vue&type=template&id=e5f38ce2&scoped=true"
import script from "./education-video-player.vue?vue&type=script&lang=js"
export * from "./education-video-player.vue?vue&type=script&lang=js"
import style0 from "./education-video-player.css?vue&type=style&index=0&id=e5f38ce2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f38ce2",
  null
  
)

export default component.exports